export default {"src":"/_next/static/media/ic-hint.52ac9523.svg","height":21,"width":21};